import React, { useState, useEffect, useRef } from "react";
import { Breadcrumb, BreadcrumbItem } from "reactstrap";


const CustomBreadCrumbs = () => {
    return (
        <>
            <div className="container container_cust">
                <div className="bread_crumb_list">
                    <Breadcrumb>
                        <BreadcrumbItem>
                            <a href="#">
                                Home
                            </a>
                        </BreadcrumbItem>
                        <BreadcrumbItem>
                            <a href="#">
                               Viksit Bharat Fellowship
                            </a>
                        </BreadcrumbItem>
                        <BreadcrumbItem active>
                            Application Form
                        </BreadcrumbItem>
                    </Breadcrumb>
                </div>
            </div>
        </>
    )
}


export default CustomBreadCrumbs;